export const RESET = 'EXCMREGIONUSERDATA_UPDATE_RESET'
export const SET_ERROR = 'EXCMREGIONUSERDATA_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMREGIONUSERDATA_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMREGIONUSERDATA_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMREGIONUSERDATA_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMREGIONUSERDATA_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMREGIONUSERDATA_UPDATE_UPDATE_RETRIEVED'
